import { makeApi } from "@zodios/core";
import { z } from "zod";

import { sectionAppliancesResponseSchema, patchSectionSchema } from "@/data/api/kili/sections/sections.type";

export const sectionsApi = makeApi([
  {
    method: "get",
    path: "/:sectionId/appliances",
    response: sectionAppliancesResponseSchema,
    alias: "getSectionAppliances",
    parameters: [
      {
        type: "Path",
        name: "sectionId",
        schema: z.number(),
      },
    ],
  },
  {
    method: "patch",
    path: "/:sectionId",
    parameters: [
      {
        type: "Path",
        schema: z.number(),
        name: "sectionId",
      },
      {
        type: "Body",
        name: "body",
        schema: patchSectionSchema,
      },
    ],
    response: z.unknown(),
    alias: "patchSiteSection",
  },
]);
